import { createContext, useContext } from 'react';
import type { RequiredVideoState } from '@/hooks/use-required-video';
import type { RequiredVideoConfig } from '@/types/required-video';

export type RequiredVideoCtxValue = {
  state: RequiredVideoState;
  config: RequiredVideoConfig | null;
  loading: boolean;
  error: string | null;
};

export const RequiredVideoCtx = createContext<RequiredVideoCtxValue | null>(
  null
);

export function useRequiredVideoCtx(): RequiredVideoCtxValue {
  const v = useContext(RequiredVideoCtx);
  if (!v) {
    throw new Error('Required-video components must be inside <RequiredVideo>');
  }
  return v;
}

export type RequiredVideoStatus = {
  completed: boolean;
  remainingSecs: number;
  loading: boolean;
  available: boolean;
};

export function useRequiredVideoStatus(): RequiredVideoStatus {
  const { state, loading, config } = useRequiredVideoCtx();
  return {
    completed: state.completed,
    remainingSecs: state.remainingSecs,
    loading,
    available: config !== null,
  };
}
